const EditISP = () => {
    return (
        <div>Edit ISP</div>
    )
}

export default EditISP